import { z } from 'zod';

import { type IEndpointSchema, makeEndpoint } from '../common';

const BulkUpdateTaxSchema = z.object({
  id: z.string().uuid().optional(),
  name: z.string(),
});

export type IBulkUpdateTaxesSchema = z.infer<typeof BulkUpdateTaxSchema>;

export const UpdateBrandTaxesSchema = z.object({
  taxes: z.array(BulkUpdateTaxSchema),
});

export const UpdateBrandTaxesEndpoint = makeEndpoint({
  method: 'PATCH',
  url: ({ brandId }: { brandId: string }) => `v1/brands/${brandId}/taxes`,
  responseSchema: z.void(),
  requestSchema: UpdateBrandTaxesSchema,
});

export type IUpdateBrandTaxesEndpoint = IEndpointSchema<typeof UpdateBrandTaxesEndpoint>;

const BrandTaxSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
});

export type IBrandTax = z.infer<typeof BrandTaxSchema>;
